<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-toolbar>
        <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly">
          {{ $t('reports.reports_title') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-container
        fluid
        elevation-2
        style="max-height: 75vh"
        class="scrollDesign"
      >
        <v-layout row wrap>
          <v-flex xs12 sm6 md6 lg4>
            <v-card
              class="elevation-0 expandableContainer zoomR"
              to="reports/Aforo"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/Temperatura.png')"
                aspect-ratio="2.75"
              >
                <v-container fluid pa-2>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        {{ $t('reports.capacity_report_title') }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div style="margin-bottom: 19px">
                    {{ $t('reports.capacity_report_details') }}
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <span>Detalles</span>
                </v-tooltip>
                <!--<<v-btn style="padding: 0px" flat color="primary" >Ver</v-btn>
                  v-btn style="padding: 0px" flat color="primary" to="reports/student-entries">Alumnos</v-btn>
                  <v-btn style="padding: 0px" flat color="primary" to="reports/collaborator-entries">Colaboradores</v-btn>
                  <v-btn style="padding: 0px" flat color="primary" to="reports/parent-entries">Tutores</v-btn>
                  <v-btn style="padding: 0px" flat color="primary" to="reports/visit-entries">Visitas</v-btn>-->
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex flexbox xs12 sm6 md6 lg4>
            <v-card
              class="elevation-0 expandableContainer zoomR"
              to="reports/Historic"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/ReporteAforo.png')"
                aspect-ratio="2.75"
              >
                <v-container fluid pa-2>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        {{ $t('reports.check_in_and_check_out_report_title') }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div style="text-align: left">
                    {{ $t('reports.check_in_and_check_out_report_details') }}
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <span>Detalles</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex flexbox xs12 sm6 md6 lg4>
            <v-card
              class="elevation-0 expandableContainer"
              to="reports/outings"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/reporte-salidas.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        {{ $t('reports.delivery_report_title') }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div style="margin-bottom: 18px">
                    Registro de entrega de alumnos y estatus de solicitudes
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <span>Detalles</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex flexbox xs12 sm6 md6 lg4>
            <v-card
              class="elevation-0 expandableContainer"
              @click="reportNotices"
              role="button"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/Reporte-Eventos.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        {{ $t('reports.event_registration_title') }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>
                    {{ $t('reports.event_registration_details') }}
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <!-- <v-btn icon ripple slot="activator" to="reports/details">
										<v-icon color="primary">remove_red_eye</v-icon>
                  </v-btn>-->
                  <span>Detalles</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex flexbox xs12 sm6 md6 lg4 v-if="true">
            <v-card
              class="elevation-0 expandableContainer"
              to="reports/Attendance"
              role="button"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/reporte-asistencia.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        Reporte de Asistencia
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>Registro histórico de asistencia de los alumnos</div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <!-- <v-btn icon ripple slot="activator" to="reports/details">
										<v-icon color="primary">remove_red_eye</v-icon>
                  </v-btn>-->
                  <span>Detalles</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex flexbox xs12 sm6 md6 lg4>
            <v-card
              class="elevation-0 expandableContainer"
              to="reports/third_authorizations"
              role="button"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/report_third_auth.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        Reporte de permisos de terceros
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>
                    Reporte de permisos de terceros autorizados por los tutores
                  </div>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md6 lg4 v-if="!isNormalSchool()">
            <v-card
              class="elevation-0 expandableContainer"
              to="reports/Workshopreport"
            >
              <v-img
                :src="require('@/assets/reports/reporte-talleres.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        Reporte de asistencias
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>Visualiza las asistencias de los talleres</div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <!-- <v-btn icon ripple slot="activator" to="reports/details">
                                        <v-icon color="primary">remove_red_eye</v-icon>
                  </v-btn>-->
                  <span>Detalles</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>

          <!--<v-flex xs12 sm6 md6 lg4>
            <v-card class="elevation-0 expandableContainer">
              <v-img :src="require('@/assets/reports/slides_2,2.jpg')" aspect-ratio="2.75">
                <v-container fluid pa-2>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">Reporte de asistencia</span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>Reporte de asistencia de alumnos de la institución, agrupados por niveles, en el rango de fechas señalado</div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <v-btn icon ripple slot="activator" to="reports/details">
										<v-icon color="primary">remove_red_eye</v-icon>
                  </v-btn>
                  <span>Detalles</span>
                </v-tooltip>
                <v-btn flat color="primary" @click="reportAttendance">Descargar</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>-->
        </v-layout>
        <confirm
          :class="!confirm.value ? 'position-no' : ''"
          :value="confirm.value"
          :title="confirm.title"
          :description="confirm.description"
        ></confirm>

        <!--v-on:desition="desitionDelete"-->
        <loading v-model="working.wLoading" text="Trabajando"></loading>
        <success v-model="toast.success" text="Operación Exitosa"></success>
        <error v-model="toast.failed" text="Ups ocurrió un error"></error>
        <EventsReports
          v-on:close="closeEvents"
          v-model="modals.events"
          :value="modals.events"
        ></EventsReports>
        <DeliverReports
          v-on:close="closeDelivers"
          v-model="modals.delivers.show"
          :value="modals.delivers.show"
          :body="modals.delivers.body"
        ></DeliverReports>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import jsPDF from 'jspdf'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { isNormalSchool } from '../../../plugins/GeneralMethods'
import confirm from '../../Dialogs/Confirm'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
import DeliverReports from '../../Modals/DeliverReportsModal'
import EventsReports from '../../Modals/EventReportsModal'
export default {
  components: {
    confirm,
    loading,
    success,
    error,
    EventsReports,
    DeliverReports,
  },
  props: [],
  data: () => ({
    timeFirst: new Date().toISOString().substr(0, 10),
    timeLast: new Date().toISOString().substr(0, 10),
    menu: false,
    modalF: false,
    modalL: false,
    menu2: false,
    modals: {
      events: false,
      delivers: {
        show: false,
        body: {},
      },
    },
    confirm: {
      value: false,
      title: '',
      description: '',
      show: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    working: {
      wLoading: false,
    },
    report: {},
  }),
  created() {},
  mounted() {},
  watch: {
    getBranch() {},
  },
  methods: {
    isNormalSchool() {
      return isNormalSchool(this.getBranch)
    },
    reportAttendance() {
      let firstMoment = moment(this.timeFirst, 'YYYY-MM-DD')
        .hour(0)
        .minute(0)
        .second(0)
      var dateObjB = firstMoment.toDate()
      var monthB = dateObjB.getMonth() + 1 //months from 1-12
      var dayB = dateObjB.getDate()
      var yearB = dateObjB.getFullYear()

      let lastMoment = moment(this.timeLast, 'YYYY-MM-DD')
        .hour(0)
        .minute(0)
        .second(0)
      var dateObjE = lastMoment.toDate()
      var monthE = dateObjE.getMonth() + 1 //months from 1-12
      var dayE = dateObjE.getDate()
      var yearE = dateObjE.getFullYear()
      var body = {
        yearB: yearB.toString(),
        monthB: monthB.toString(),
        dayB: dayB.toString(),
        yearE: yearE.toString(),
        monthE: monthE.toString(),
        dayE: dayE.toString(),
      }

      this.$store
        .dispatch('reports/getAttendance', body)
        .then((response) => {
          this.reports = response.data.entity
          this.createPDF('download', 'attendance')
        })
        .catch((error) => {
          this.toast.failed = true
          console.log(error)
        })
    },

    reportOuts() {
      let firstMoment = moment(this.timeFirst, 'YYYY-MM-DD')
        .hour(0)
        .minute(0)
        .second(0)
      var dateObjB = firstMoment.toDate()
      var monthB = dateObjB.getMonth() + 1 //months from 1-12
      var dayB = dateObjB.getDate()
      var yearB = dateObjB.getFullYear()

      let lastMoment = moment(this.timeLast, 'YYYY-MM-DD')
        .hour(0)
        .minute(0)
        .second(0)
      var dateObjE = lastMoment.toDate()
      var monthE = dateObjE.getMonth() + 1 //months from 1-12
      var dayE = dateObjE.getDate()
      var yearE = dateObjE.getFullYear()
      var body = {
        yearB: yearB.toString(),
        monthB: monthB.toString(),
        dayB: dayB.toString(),
        yearE: yearE.toString(),
        monthE: monthE.toString(),
        dayE: dayE.toString(),
      }

      this.$store
        .dispatch('reports/getOuts', body)
        .then((response) => {
          this.reports = response.data.entity
          this.createPDF('download', 'out')
        })
        .catch((error) => {
          this.toast.failed = true
          console.log(error)
        })
    },

    createPDF(action, type) {
      const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ]
      var headers = []
      var bodyTable = []
      let doc = new jsPDF('p', 'pt')
      let branch = this.getBranch
      let fDate =
        new Date(this.timeFirst).getDate() +
        1 +
        '/' +
        months[new Date(this.timeFirst).getMonth()] +
        '/' +
        new Date(this.timeFirst).getFullYear()
      let lDate =
        new Date(this.timeLast).getDate() +
        1 +
        '/' +
        months[new Date(this.timeFirst).getMonth()] +
        '/' +
        new Date(this.timeFirst).getFullYear()
      var pdfName = 'Reporte'
      var header = function (data) {
        doc.setFont('helvetica')
        doc.setFontType('bold')
        doc.setFontSize(25)
        doc.text('Colegio ' + branch.name, 150, 45)
        doc.setFont('helvetica')
        doc.setFontSize(13)
        doc.text(
          type == 'attendance' ? 'Reporte de Asistencia' : 'Reporte de Salida',
          150,
          70
        )
        doc.text('Periodo: ' + fDate + ' -- ' + lDate, 150, 115)
        var splitTitle = doc.splitTextToSize(branch.address, 400)
        var y = 90
        for (var i in splitTitle) {
          doc.text(splitTitle[i], 150, y)
          y += 12
        }
        if (branch.img != null && branch.img != '') {
          var imgData =
            branch.img == null ? '' : 'data:image/jpg;base64, ' + branch.img
          doc.addImage(imgData, 'JPEG', data.settings.margin.left, 10, 100, 100) //(imagen,formato,x-pos,y-pos, width,heigth)
        }
      }

      //Headers
      headers[0] = 'Nombre'
      for (let g of this.reports.groups) {
        headers.push(g.name)
      }
      headers[headers.length] = 'Total'

      //Body
      for (let item of this.reports.levels) {
        for (const [index, grade] of item.grades.entries()) {
          var row = []
          row[0] = item.name + ' ' + grade.name
          for (const [index, item] of this.reports.groups.entries()) {
            forG: for (let a of grade.groups) {
              if (item.name == a.name) {
                row[index + 1] = a.attendance
                break forG
              }
            }
            row[index + 1] = row[index + 1]
          }
          row[row.length] = grade.totalByGrade

          bodyTable[bodyTable.length] = row
        }
        bodyTable[bodyTable.length] = [
          'Total de ' + item.name + ': ',
          item.totalByLevel,
        ]
      }
      bodyTable[bodyTable.length] = []
      bodyTable[bodyTable.length] = [
        'Total Estudiantes: ',
        this.reports.totalStudents,
      ]
      doc.autoTable({
        head: [headers],
        body: bodyTable,
        margin: {
          top: 120,
        },
        styles: {
          fontSize: 10,
          verticalcell: 60,
          cellWidth: 'grid',
        },
        columnStyles: {
          0: {
            fontSize: 15,
          },
        },
        didDrawPage: header,
        didParseCell: function (data) {
          if (data.cell.text[0].includes('Total')) {
            data.cell.styles.fillColor = [41, 128, 185]
            data.cell.styles.textColor = 255
            data.cell.styles.halign = 'center'
          }
        },
      })
      doc.save(pdfName + '.pdf')
    },
    reportNotices() {
      this.modals.events = true
    },
    reportDelivers() {
      let firstMoment = moment(this.timeFirst, 'YYYY-MM-DD')
        .hour(0)
        .minute(0)
        .second(0)
      var dateObjB = firstMoment.toDate()
      var monthB = dateObjB.getMonth() + 1 //months from 1-12
      var dayB = dateObjB.getDate()
      var yearB = dateObjB.getFullYear()

      let lastMoment = moment(this.timeLast, 'YYYY-MM-DD')
        .hour(0)
        .minute(0)
        .second(0)
      var dateObjE = lastMoment.toDate()
      var monthE = dateObjE.getMonth() + 1 //months from 1-12
      var dayE = dateObjE.getDate()
      var yearE = dateObjE.getFullYear()
      var body = {
        yearB: yearB.toString(),
        monthB: monthB.toString(),
        dayB: dayB.toString(),
        yearE: yearE.toString(),
        monthE: monthE.toString(),
        dayE: dayE.toString(),
      }
      this.modals.delivers.body = body
      this.modals.delivers.show = true
    },
    closeEvents(val) {
      this.modals.events = val
    },
    closeDelivers(val) {
      this.modals.delivers.show = val
      this.modals.delivers.body = {}
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    onCancel() {
      this.modals.events = false
      this.modals.delivers.show = false
      this.$forceUpdate()
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  computed: {
    momentFormatFirst() {
      if (this.timeFirst != null) {
        return moment(this.timeFirst).format('DD/MM/YYYY')
      }
      return ''
    },
    momentFormatLast() {
      if (this.timeLast != null) {
        return moment(this.timeLast).format('DD/MM/YYYY')
      }
      return ''
    },
    ...mapGetters(['getBranch']),
  },
}
</script>
<style>
.no-padding {
  padding-left: 10%;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}
.expandableContainer {
  border-style: solid !important;
  border-color: #e6e6e6 !important;
  border-radius: 15px !important;
  border-width: 2px !important;
}
</style>
